import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Text } from 'office-ui-fabric-react/lib/Text';
import Card from '../Card';
import styles from './CardHeader.style';

const CardHeader = ({
  variant,
  extra,
  leftBorder,
  children,
  className: classNameProp,
  ...other
}) => {
  const className = clsx(styles.root, classNameProp, {
    [styles.large]: variant === 'large',
    [styles.leftBorder]: leftBorder,
  });
  const asMap = {
    normal: 'h3',
    large: 'h2',
  };

  return (
    <div className={styles.borderWrapper}>
      <Card disableDepth leftBorder={leftBorder} className={className} {...other}>
        <Text as={asMap[variant]} block className={styles.title}>
          {children}
        </Text>

        {extra}
      </Card>
    </div>
  );
};

CardHeader.propTypes = {
  extra: PropTypes.node,
  variant: PropTypes.oneOf(['normal', 'large']),
  leftBorder: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

CardHeader.defaultProps = {
  extra: null,
  variant: 'normal',
  leftBorder: false,
  className: 'normal',
};

export default CardHeader;
